import React from "react";
import Sheet from "components/sheet/Sheet";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import "./foodOrderDetails.scss";
import Input from "components/form/input/Input";
import Divider from "components/divider";
import { IFoodOrder } from "api/rpc/2024-04/facilityAdmin/facility/foodOrdering";
import { faClock, faGolfFlagHole, faLocationDot, faPhone, faReceipt, faUser } from "@fortawesome/pro-light-svg-icons";
import { capitalize, capitalizeWords } from "helpers/Helpers";
import { useTranslation } from "react-i18next";
import moment from "moment";

type FoodOrderDetailProps = {
  isActive: boolean;
  order?: IFoodOrder;
  onClick?: () => void;
  onCancel?: () => void;
};

export default function FoodOrderDetails(props: FoodOrderDetailProps) {
  const { order } = props;
  const { t } = useTranslation();
  function setRegisterCart() {
    if (order?.order?.cart_token) {
      //Send cart token to register page to continue order
      window.open(`/admin/register?order_id=${String(order?.order.id)}&token=${String(order?.order?.cart_token)}`);
    }
  }

  return (
    <Sheet
      size="small"
      closable
      onOk={setRegisterCart}
      okDisabled={order?.order?.financial_status === "paid" ? true : false}
      okText={t("secure.facility.food_order.food_order_details.food_order_details.001")}
      fullWidthOK
      onCancel={props.onCancel}
      hideCancelButton
      backDropCancel
      open={props.isActive}
    >
      <div>
        <div className="fa-stacks fa-layers">
          {/* Outer Circle */}
          <span className="fa-bigger-circle"></span>

          {/* Inner Circle */}
          <span className="fa-smaller-circle"></span>

          {/* Receipt */}
          <span className="fa-receipt">
            <FontAwesomeIcon icon={faReceipt} fixedWidth size="lg" />
          </span>
        </div>
      </div>

      {/* Order Header - Order Name - Price */}
      <div className="chit-details-header pt-7">
        <div className="chit-number-and-price">
          <span>
            {t("secure.facility.food_order.food_order_details.food_order_details.002")} {order?.name}
          </span>
          <span className="circle-divider"></span>
          <span>${order?.order?.total_price}</span>
        </div>
      </div>

      <div className="font-400">
        <span>{t("secure.facility.food_order.food_order_details.food_order_details.003")}</span>
      </div>

      {/* Customer Details  */}
      <div className="chit-details-body">
        <div className="chit-details-body-container">
          <div className="chit-details-body-id">
            <FontAwesomeIcon icon={faUser} size="lg" />
            <span className="pl-2">{t("secure.facility.food_order.food_order_details.food_order_details.004")}</span>
          </div>
          <div className="chit-details-body-value">
            <span>
              {order?.order?.customer?.full_name
                ? capitalizeWords(order?.order?.customer?.full_name)
                : t("secure.facility.food_order.food_order_details.food_order_details.005")}{" "}
            </span>
          </div>
        </div>

        <Divider className="mt-4! mb-4!" />

        {/* Customer Phone */}
        <div className="chit-details-body-container">
          <div className="chit-details-body-id">
            <FontAwesomeIcon icon={faPhone} size="lg" />
            <span className="pl-2">{t("secure.facility.food_order.food_order_details.food_order_details.006")}</span>
          </div>
          <div className="chit-details-body-value">
            {order?.order?.customer_phone
              ? order?.order?.customer_phone
              : t("secure.facility.food_order.food_order_details.food_order_details.007")}
          </div>
        </div>

        <Divider className="mt-4! mb-4!" />

        {/* PickUp Location */}
        <div className="chit-details-body-container">
          <div className="chit-details-body-id">
            <FontAwesomeIcon icon={faLocationDot} size="lg" />
            <span className="pl-2">{t("secure.facility.food_order.food_order_details.food_order_details.008")}</span>
          </div>
          <div className="chit-details-body-value">
            {order?.order?.pickup_location.name
              ? capitalize(order?.order?.pickup_location.name)
              : t("secure.facility.food_order.food_order_details.food_order_details.009")}{" "}
          </div>
        </div>

        <Divider className="mt-4! mb-4!" />

        {/* Pickup Time */}
        <div className="chit-details-body-container">
          <div className="chit-details-body-id">
            <FontAwesomeIcon icon={faClock} size="lg" />
            <span className="pl-2">{t("secure.facility.food_order.food_order_details.food_order_details.010")}</span>
          </div>
          <div className="chit-details-body-value">
            {order?.order?.pickup_time
              ? moment(order?.order.pickup_time, "hh:mm A").format("LT")
              : t("secure.facility.food_order.food_order_details.food_order_details.014")}
          </div>{" "}
        </div>

        <Divider className="mt-4! mb-4!" />

        {/* Current Tee */}
        <div className="chit-details-body-container">
          <div className="chit-details-body-id">
            <FontAwesomeIcon icon={faGolfFlagHole} size="lg" />
            <span className="pl-2">{t("secure.facility.food_order.food_order_details.food_order_details.011")} </span>
          </div>
          <div className="chit-details-body-value pl-4">
            {order?.order?.tee
              ? order?.order?.tee
              : t("secure.facility.food_order.food_order_details.food_order_details.012")}
          </div>{" "}
        </div>
      </div>

      {/* Order Notes */}
      {order?.order?.notes ? (
        <div className="flex flex-col">
          {t("secure.facility.food_order.food_order_details.food_order_details.013")}
          <Input value={order?.order?.notes} disabled />
        </div>
      ) : null}
    </Sheet>
  );
}
